// Volba "Popisek stanice" — zaškrtávátka volí, která pole stanice se zobrazí jako
// popisek řádku (každé vybrané pole na svém řádku pod sebou). Stav je GLOBÁLNÍ
// (useStationLabelStore) — sdílený přes všechny skupinové produkty (jevy,
// měsíční/roční, měřené veličiny) i nabídku dotažení dat. Dřív per-produkt.

export const STATION_LABEL_FIELDS = [
  { key: 'gh_id',     label: 'ID' },
  { key: 'name',      label: 'Název' },
  { key: 'full_name', label: 'Plný název' },
  { key: 'qual',      label: 'Upřesnění' },
]

// Řádky popisku stanice podle zvolených polí (fallback na gh_id, když nic nevybráno).
export function stationLabelLines(station, labelFields, ghId) {
  if (!labelFields || labelFields.length === 0) return [station?.name ?? ghId]
  return labelFields.map(key => station?.[key] ?? '')
}

export function StationLabelPicker({ labelFields, onChange }) {
  function toggle(key) {
    onChange(labelFields.includes(key) ? labelFields.filter(k => k !== key) : [...labelFields, key])
  }
  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-xs text-gray-400 font-medium uppercase tracking-wide">Popisek stanice</span>
      {STATION_LABEL_FIELDS.map(f => (
        <label key={f.key} className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer">
          <input
            type="checkbox"
            checked={labelFields.includes(f.key)}
            onChange={() => toggle(f.key)}
            className="accent-blue-600"
          />
          {f.label}
        </label>
      ))}
    </div>
  )
}
